import $ from "jquery";
import Tooltip from "bootstrap/js/dist/tooltip";

const contactLpFormBtn = document.querySelector('#contactLpFormBtnWrapper');
let contactLpFormBtnTooltip;

if (contactLpFormBtn != null && contactLpFormBtn.length < 1) {
    contactLpFormBtnTooltip = new Tooltip(contactLpFormBtn, {
        trigger: 'click'
    });
}

$('#whitelabelCategories input').each(function() {
    $(this).addClass('form-check-input');
});

$('#contactLpFormCheckboxes input:checkbox').on('click', function() {
    if ($('#contactLpFormCheckboxes input:checkbox:checked').length > 0) {
        $('#contactLpFormCheckboxes')
            .removeClass('red-border')
            .find('.alert-icon').css('opacity', 0);

        $('#contactLpFormCheckboxes').find('.alert-message').css('opacity', 0);
    } else {
        $('#contactLpFormCheckboxes')
            .addClass('red-border')
            .find('.alert-icon').css('opacity', 1);

        $('#contactLpFormCheckboxes').find('.alert-message').css('opacity', 1);
    }

    okToContinue();
});

$('#email').on('blur', function() {
    if ( ! $(this).val()) {
        $(this)
            .addClass('red-border')
            .next('.alert-icon').css('opacity', 1)
            .next('.alert-message').css('opacity', 1);
    } else {
        $(this)
            .removeClass('red-border')
            .next('.alert-icon').css('opacity', 0)
            .next('.alert-message').css('opacity', 0);
    }

    okToContinue();
});

$('#privacyPolicy').on('click', function() {
    okToContinue();
});

if (contactLpFormBtn != null && contactLpFormBtn.length < 1) {
    $(contactLpFormBtn).on('click', function() {
        okToContinue();
    });
    
}

function okToContinue() {
    let okToContinue = false;

    if (contactLpFormBtn != null && contactLpFormBtn.length < 1) {
        contactLpFormBtnTooltip.hide();
    }

    if ($('#contactLpFormCheckboxes input:checkbox:checked').length > 0) {
        okToContinue = true;
    } else {
        okToContinue = false;
        $('#contactLpFormCheckboxes').addClass('red-border').find('.alert-icon').css('opacity', 1);
    }

    if ( ! $('#email').val()) {
        okToContinue = false;
        $('#email').addClass('red-border').find('.alert-icon').css('opacity', 1);
    }

    if ( ! $('#privacyPolicy').is(':checked')) {
        okToContinue = false;
        $('#privacyPolicy').addClass('red-border').find('.alert-icon').css('opacity', 1);
    } else {
        $('#privacyPolicy').removeClass('red-border');
    }

    if ($('span[data-name="your_email"] span[aria-hidden="true"').length > 0) {
        $('span[data-name="your_email"] input').addClass('red-border').find('.alert-icon').css('opacity', 1);
        okToContinue = false;
    }

    if (contactLpFormBtn != null && contactLpFormBtn.length < 1) {
        if (okToContinue) {
            contactLpFormBtnTooltip.disable();
            $('#contactLpFormBtn').prop('disabled', '').addClass('btn-primary');
        } else {
            contactLpFormBtnTooltip.enable();
            $('#contactLpFormBtn').prop('disabled', 'disabled').removeClass('btn-primary');
        }
    }
}

$(document).on('ready', function() {
    $('.contact-lp__section').css('overflow-x', 'hidden');
    $('#contactLpFormBtn').prop('disabled', true);

    $("#contactLpForm").on('submit', function(e){
        e.preventDefault();

        window.location.href = "/white-label-thank-you";
    });
});
